import { useMemo, useRef } from 'react'
import { arrayOf, shape, string, func, node, object, bool } from 'prop-types'
import { useParams } from 'react-router-dom'
import { BaseFeedbackConIcona } from 'feedback'
import { BaseButtons } from 'inputs'
import { BaseGridLayout } from 'layout'
import { sx } from 'utils'
import TabsSincronizzateConRotta from './TabsSincronizzateConRotta'

WizardSincronizzatoConRotta.propTypes = {
  tabs: arrayOf(shape({
    chiave: string.isRequired,
    titolo: node.isRequired,
    Contenuto: func.isRequired,
    validate: shape({
      condition: func.isRequired,
      message: string
    }),
    propsBottoneAvanti: object,
    propsBottoneIndietro: object,
    onEnter: func,
    onLeave: func,
    onNextStep: func,
    onPrevStep: func,
  })).isRequired,
  nascondiBottoneIndietro: bool,
  onClickBottoneAvantiUltimaTab: func,
  onClickBottoneIndietroPrimaTab: func,
  labelBottoneAvanti: string,
  labelBottoneIndietro: string,
  nomeParamTab: string,
  noPaddingX: bool,
  // ...props di TabsSincronizzateConRotta
}

export default function WizardSincronizzatoConRotta(props) {
  const {
    tabs,
    nascondiBottoneIndietro,
    onClickBottoneAvantiUltimaTab,
    onClickBottoneIndietroPrimaTab,
    labelBottoneAvanti = 'Avanti',
    labelBottoneIndietro = 'Indietro',
    nomeParamTab = 'tab',
    noPaddingX,
    ...propsTabs
  } = props

  const tabsDefinitive = useMemo(
    () => tabs.map(({ validate, ...restTab }) => ({
      ...restTab,
      disabled: validate ? !validate.condition() : false,
    })),
    [tabs]
  )

  const { [nomeParamTab]: tab } = useParams()
  const indiceTabVisibile = tabsDefinitive.findIndex(({ chiave, disabled }) => chiave === tab && !disabled)
  const indiceProssimaTab = indiceTabVisibile + 1
  const isUltimaTabVisibile = indiceTabVisibile === tabs.length - 1
  const indiceTabPrecedente = indiceTabVisibile - 1
  const isPrimaTabVisibile = indiceTabVisibile === 0

  const inputRef = useRef()

  function vaiProssimaTab() {
    if (isUltimaTabVisibile && onClickBottoneAvantiUltimaTab) onClickBottoneAvantiUltimaTab()
    else inputRef.current?.onChangeTab(indiceProssimaTab)
  }

  function vaiTabPrecedente() {
    if (isPrimaTabVisibile && onClickBottoneIndietroPrimaTab) onClickBottoneIndietroPrimaTab()
    else inputRef.current?.onChangeTab(indiceTabPrecedente)
  }

  function onEnterTab() {
    tabs[indiceTabVisibile]?.onEnter?.()
  }

  function onLeaveTab(indiceTabPrecedente, indiceTabDestinazione) {
    tabs[indiceTabVisibile]?.onLeave?.()
    if (indiceTabDestinazione > indiceTabPrecedente) {
      tabs[indiceTabVisibile]?.onNextStep?.()
    } else if (indiceTabDestinazione < indiceTabPrecedente) {
      tabs[indiceTabVisibile]?.onPrevStep?.()
    }
  }

  const { condition, message } = tabs[indiceProssimaTab]?.validate || { condition: () => true }
  const messaggioDaMostrare = condition() ? null : message
  const propsBottoneAvanti = {
    testo: labelBottoneAvanti,
    ...(condition() ? { onClick: vaiProssimaTab } : { disabled: true }),
    ...tabs[indiceTabVisibile]?.propsBottoneAvanti
  }
  const bottoneAvantiNascosto = isUltimaTabVisibile && !onClickBottoneAvantiUltimaTab

  const propsBottoneIndietro = {
    testo: labelBottoneIndietro,
    variant: 'text',
    onClick: vaiTabPrecedente,
    ...tabs[indiceTabVisibile]?.propsBottoneIndietro
  }
  const bottoneIndietroNascosto = nascondiBottoneIndietro || (isPrimaTabVisibile && !onClickBottoneIndietroPrimaTab)

  return (
    <>
      <TabsSincronizzateConRotta
        tabs={tabsDefinitive}
        inputRef={inputRef}
        onEnterTab={onEnterTab}
        onLeaveTab={onLeaveTab}
        nomeParamTab={nomeParamTab}
        {...(noPaddingX && { propsContenutoTab: { propsBox: { px: 0 } } })}
        {...propsTabs}
      />

      <BaseGridLayout justifySpaceBetween sx={{ ...(!noPaddingX && { px: 3 }) }} noWrap>
        <BaseButtons.MenoDettagli
          {...propsBottoneIndietro}
          {...sx(propsBottoneIndietro, { p: 0, ...(bottoneIndietroNascosto && { visibility: 'hidden', width: 0 }) })}
        />
        <BaseButtons.Dettagli
          {...propsBottoneAvanti}
          {...sx(propsBottoneAvanti, { ...(bottoneAvantiNascosto && { visibility: 'hidden', width: 0 }) })}
        />
      </BaseGridLayout>

      {messaggioDaMostrare &&
        <BaseFeedbackConIcona.Errore messaggio={messaggioDaMostrare} noWrap />
      }
    </>
  )
}